import Vue from 'vue';
import Vuetify from 'vuetify/lib'
import 'vuetify/dist/vuetify.min.css';
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'mdi',
    },
    theme: {
        themes: {
            light: {
                primary: {
                    base: '#1976D2',
                },
                "highlight-1": '#fcbc14',
                "highlight-2": '#42A5F5',
                error: '#D32F2F',
                red: '#D32F2F',
                success: '#05c544',
                green: '#05c544',
                grey: {
                    darken4: '#11231f',
                    darken3: '#414f4c',
                    darken2: '#586562',
                    darken1: '#707879',
                    base: '#6B7280',
                    lighten1: '#9fa7a5',
                    lighten2: '#b8bdbc',
                    lighten3: '#cfd3d2',
                    lighten4: '#e7e9e9',
                    lighten5: '#fafbfb',
                },
            },
        },
    },
});
